module.exports = __webpack_public_path__ + "static/scale-model-of-rockhaven-in-pasadena-california-9c9066b96cdfe8f46249945fc73e7fc1.png";